import * as React from 'react';
import { Form } from 'react-bootstrap';
import { useDropzone, DropzoneOptions } from 'react-dropzone';

import {
  InputGroup,
  InputGroupAppend,
  InputGroupButton,
  Label,
  TextInput,
} from '../../components/Input';

import classes from './add-warranty.module.scss';

type UploadFileProps = {
  file?: File;
  onDrop: DropzoneOptions['onDrop'];
};

export const UploadFile: React.FC<UploadFileProps> = ({ file, onDrop }) => {
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps({ style: { outline: 'none' } })}>
      <input {...getInputProps()} />

      <Label>Carica scontrino *</Label>
      <InputGroup>
        <TextInput as={'span'} className={classes.uploadSpan} required={true}>
          {file && file.name}
        </TextInput>

        <InputGroupAppend>
          <InputGroupButton variant={'secondary'}>Sfoglia</InputGroupButton>
        </InputGroupAppend>

        <Form.Text className={'text-muted'}>
          Con l'inserimento dello scontrino potrai ricevere coupon e sconti
          personalizzati
          <br />
          <i>
            Nota: per gli acquisti Amazon o altre piattaforme digitali è
            sufficiente caricare uno screenshot della conferma d'ordine.
          </i>
        </Form.Text>
      </InputGroup>
    </div>
  );
};
